import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import AddEditFormCst from "@components/AddEditFormCst";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { useFetchDetail, usePutDetail } from "@hooks/useFetchDetail";
import { ServicesURL, uploadFile } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { ColumnsType } from "src/interfaces/Common";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { submitUpload } from "@pages/Contents/BadgeAndCertificates/utils/utils";
import AddEditFormNewCst from "@components/AddEditFormNewCst";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { MethodType } from "src/services/type";

interface Props {
  externalTrainingId: any;
  onSuccess: () => void;
  onlyVisualization?: boolean;
}

const EditModal: React.FC<Props> = ({
  externalTrainingId,
  onSuccess,
  onlyVisualization = false,
}) => {
  const { t } = useTranslation(["rooms-page"]);
  const { id = "1" } = useParams();
  const [editColumns, setEditColumns] = useState<ColumnsType | any>();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  const { columns, dataDetail, mutate } = useFetchDetail(
    ServicesURL.getSingleExternalTraining,
    externalTrainingId,
    PagesID["skillBookNew-add"],
  );

  const onSubmit = async (inputForm: any) => {
    const objectToSend: any = {
      ...inputForm,
      campaignId: Number(inputForm.campaign),
      capability: inputForm.capability ?? dataDetail?.capability,
      area: inputForm.area ?? dataDetail?.area,
      id: dataDetail?.id,
      status: dataDetail?.status,
      year: dataDetail?.year,
      corporateId: dataDetail?.corporateId,
      learnerId: dataDetail?.learnerId,
    };

    if (
      objectToSend.durationMinutes === undefined ||
      isNaN(objectToSend.durationMinutes) ||
      Number(objectToSend.durationMinutes) < 0
    )
      return;

    objectToSend.durationParticipation = Number(
      inputForm.durationParticipation,
    );

    let formData = new FormData();
    (inputForm?.attachmentsArray ?? []).forEach((file: any) =>
      formData.append("attachments", file.file),
    );
    formData.append("data", JSON.stringify(objectToSend));

    try {
      if (formData) {
        await uploadFile(
          `${ServicesURL.getSingleExternalTraining}/${externalTrainingId}`,
          formData,
          MethodType.PUT,
          "multipart/form-data",
        );
        setOpenToast({ s: StatusEnum.OK, message: "" });
      }
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }
    mutate && mutate(formData);
  };

  useEffect(() => {
    if (columns) {
      const sitesCodeIndex = columns.findIndex(
        (item) => item.accessorKey === "code",
      );
      const sitesCodeObject = { ...columns[sitesCodeIndex], disabled: true };
      columns[sitesCodeIndex] = sitesCodeObject;
      setEditColumns(columns);
    }
  }, [dataDetail]);

  const heroTitle = onlyVisualization
    ? "Visualizza informazioni"
    : "Modifica Informazioni";

  const inputsException = (col: any, inputForm: any) => {
    if (col?.accessorKey === "durationMinutes") {
      if (inputForm["durationMinutes"] === undefined) {
        col.error = "required-course-duration";
      } else if (isNaN(inputForm["durationMinutes"])) {
        col.error = "type-number-value-error";
      } else if (Number(inputForm["durationMinutes"]) < 0) {
        col.error = "negative-value-error";
      } else {
        col.error = "";
      }
    }
    return col;
  };

  return (
    <>
      <HeroCst title={heroTitle} description={t("edit.hero-description")} />
      <Box>
        <AddEditFormNewCst
          row={dataDetail || []}
          actionsForForms={[]}
          columns={editColumns}
          inputsException={inputsException}
          onSubmit={onSubmit}
          backButton={onSuccess}
          readOnly={onlyVisualization}
          externalTraining={true}
        />
      </Box>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-edit")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
          mutate && mutate();
          onSuccess();
        }}
        status={openToast}
        routeToSamePage={true}
      />
    </>
  );
};

export default EditModal;
